<script setup>
    import { watch, onMounted, ref, computed } from 'vue';

    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';

    import { imageUrl, fileUrl, uploadUrl } from '@/composables/http';
    import useContacts from '@/composables/useContacts';

    import CustomPopup from '../components/modals/CustomPopup.vue';

    import SubcontractorModal from '../components/modals/SubModal.vue';
    import ClientModal from '../components/modals/ClientModal.vue';
    import ProjectsModal from '../components/modals/ProjectsModal.vue';
    import ProjectSummaryModal from '../components/modals/ProjectSummaryModal.vue';
    import FirstTimePopup from '../components/modals/FirstTimePopup.vue';
    
    const { read, loading, clientData, subContractorData, clientList, subContractorList, readClientList, readSubContractorList, createClient, updateClient, createSubContractor, updateSubContractor, createSubContractorWithProject } = useContacts();

    //setup popup varibles.

    const showFirstTimePopup = ref(false); // Controls popup visibility
    const firstTimePopupTitle = ref('Add Clients and Sub-Contractors'); // Popup title
    const firstTimeContent = ref('Have a list of clients and sub-contractors?  Add them here for easy access.'); // Popup content
    const firstTimeConfirmText = ref('OK'); // Confirm button text
    const firstTimeCurrentConfirmAction = ref(null);


    // Reactive properties
    const showPopup = ref(false); // Controls popup visibility
    const popupIconSrc = ref(null); // Custom icon source (optional)
    const iconColor = ref(''); // Icon color
    const popupTitle = ref(''); // Popup title
    const content = ref(''); // Popup content
    const cancelText = ref('');
    const confirmText = ref(''); // Confirm button text
    const confirmButtonType = ref(''); // Button type for confirmation

    const currentConfirmAction = ref(null);

    const autoClose = ref(false);

    const testData = ref(null);
    const testData2 = ref(null);

    const pageSize = ref(5);
    const clientsPage = ref(1);
    const clientsPageCount = ref(1);
    const subsPage = ref(1);
    const subsPageCount = ref(1);

    //search
    const searchByClients = ref("");
    const searchBySub = ref("");

    //subcontractor modal
    const showSubcontractorModal = ref(false);
    const showClientModal = ref(false);

    const showProjectsModal = ref(false);
    const showProjectSummaryModal = ref(false);
    const selectedSubContractor = ref(null);

    //for project summary modal
    const type = ref(null);
    const list = ref(null);
    const userId = ref(null);

    function showCustomPopup(title, message, _cancelText, _confirmText, _confirmButtonType, confirmFunction = null, _autoClose = false) {

        showPopup.value = true;
        popupTitle.value = title;
        content.value = message;

        cancelText.value = _cancelText;

        confirmText.value = _confirmText;

        confirmButtonType.value = _confirmButtonType;

        if (_confirmButtonType == 'error') {
            popupIconSrc.value = require('@/assets/images/icons/ErrorIcon.png');
        } else {
            popupIconSrc.value = require('@/assets/images/icons/SuccessIcon.png');

        }

        if (confirmFunction) {
            currentConfirmAction.value = confirmFunction;
        }
        autoClose.value = _autoClose;

    }
    function closePopup() {
        showPopup.value = false;

        // Reset values to defaults
        popupTitle.value = '';
        content.value = '';
        confirmText.value = '';
        confirmButtonType.value = '';

        popupIconSrc.value = '';
    }



    function confirmDelete(id, name) {

        showCustomPopup("Delete Client", "Are you sure you want to delete " + name + '? ', "Cancel", "Confirm", "success", () => {

            //console.log("deleteClient", id + " " + name);
            closePopup();

        }, false);
    }

    function alertMessage(message) {
        showCustomPopup(message, null, null, "OK", "error", null);
    }

    function addProject(client) {
        window.$core.data.SelectedClient = client;

        console.log(window.$core.data);
        window.$router.push('/Project');
    }

    function editClient(client) {
        clientData.value = client;

        showClientModal.value = true;

    }

    function addNewClient() {
        showClientModal.value = true;

        clientData.value = null;
    }

    function searchClients() {

        //console.log("Search Clients", searchByClients.value);
    }
    function saveClient(client) {

        if (client.Id) {

            updateClient(client, (res) => {
                if (res.Type == 200) {
                    showCustomPopup("Client Saved!", null, null, "OK", "success", null, true);
                    read();
                } else {
                    showCustomPopup(res.Content, null, null, "OK", "error", null, true);
                }
            });
        } else {

            createClient(client, (res) => {
                if (res.Type == 200) {
                    showCustomPopup("Client Created!", null, null, "OK", "success", null, true);
                    read();
                } else {
                    showCustomPopup(res.Content, null, null, "OK", "error", null, true);
                }

            });

        }

        showClientModal.value = false;
        clientData.value = null;

    }
    //subcontractor modal

    function searchSubs() {
        //console.log("Search Subs", searchBySub.value);
    }

    function addNewSub() {
        subContractorData.value = null;
        showSubcontractorModal.value = true;
    }

    function editSub(obj) {
        //console.log("editSub", obj);
        showSubcontractorModal.value = true;
        subContractorData.value = obj;

    }


    function saveSubcontractorWithProject(obj) {
        //console.log("saveSubcontractorWithProject", obj);

        //return;
        if (obj.Id) {

            createSubContractorWithProject(obj, (res) => {
                if (res.Type == 200) {
                    if (obj.ProjectId) {
                        showCustomPopup("Sub-Contractor Added to Project!", null, null, "OK", "success", null, true);

                    } else {
                        showCustomPopup("Sub-Contractor Saved!", null, null, "OK", "success", null, true);

                    }

                    read();
                } else {
                    showCustomPopup(res.Content, null, null, "OK", "error", null, true);
                }
            });
        } else {

            createSubContractorWithProject(obj, (res) => {
                if (res.Type == 200) {
                    showCustomPopup("Sub-Contractor Created!", null, null, "OK", "success", null, true);
                    read();
                } else {
                    showCustomPopup(res.Content, null, null, "OK", "error", null, true);
                }

            });

        }

        selectedSubContractor.value = null;

        showProjectsModal.value = false;
    }

    function saveSubcontractor(obj) {
        //console.log("saveSubcontractor", obj);

        if (obj.Id) {

            updateSubContractor(obj, (res) => {
                if (res.Type == 200) {
                    if (obj.ProjectId) {
                        showCustomPopup("Sub-Contractor Added to Project!", null, null, "OK", "success", null, true);

                    } else {
                        showCustomPopup("Sub-Contractor Saved!", null, null, "OK", "success", null, true);

                    }
                    
                    read();
                } else {
                    showCustomPopup(res.Content, null, null, "OK", "error", null, true);
                }
            });
        } else {

            createSubContractor(obj, (res) => {
                if (res.Type == 200) {
                    showCustomPopup("Sub-Contractor Created!", null, null, "OK", "success", null, true);
                    read();
                } else {
                    showCustomPopup(res.Content, null, null, "OK", "error", null, true);
                }

            });

        }

        showSubcontractorModal.value = false;
        subContractorData.value = null;

    }

    function addSubToProject(sub) {
        //console.log("addSubToProject", sub);
        selectedSubContractor.value = sub;

        showProjectsModal.value = true;
        
    }


    function showProjectSummary(_type, _userId){
        type.value = _type;
        userId.value = _userId;
        if(_type == "client"){
            list.value = clientList.value;
        }else{
            list.value = subContractorList.value;
        }
        showProjectSummaryModal.value = true;
    }
    function goToProject() {
        showProjectSummaryModal.value = false;
        window.$router.push('/MyProjects');
    }

    function save() {
        //console.log("save");
    }

    const filteredClients = computed(() => {
        if (!searchByClients.value.trim()) {
            return clientList.value;
        }
        var keyword = searchByClients.value.trim().toLowerCase();
        return clientList.value.filter((client) =>
            (client.FirstName + ' ' + client.LastName).toLowerCase().includes(keyword) || client.Phone.toLowerCase().includes(keyword) || client.Email.toLowerCase().includes(keyword)
        );
    });

    function paginatedClients() {

        if (clientList.value == null) {
            return [];
        }


        // Update pageCount based on filtered results and pageSize
        clientsPageCount.value = Math.ceil(filteredClients.value.length / pageSize.value);

        // Return the paginated results for the current page
        const start = (clientsPage.value - 1) * pageSize.value;
        const end = start + pageSize.value;

        //console.log("paginatedProjects", filteredProjects.length);
        return filteredClients.value.slice(start, end);
    }


    const filteredSubs = computed(() => {
        if (!searchBySub.value.trim()) {
            return subContractorList.value;
        }
        var keyword = searchBySub.value.trim().toLowerCase();
        return subContractorList.value.filter((sub) =>
            (sub.ContactFirstName + '' + sub.ContactLastName).toLowerCase().includes(keyword) || sub.Name.toLowerCase().includes(keyword) || sub.Address.toLowerCase().includes(keyword)
        );
    });
    function paginatedSubs() {

        if (subContractorList.value == null) {
            return [];
        }
        // Update pageCount based on filtered results and pageSize
        subsPageCount.value = Math.ceil(filteredSubs.value.length / pageSize.value);

        // Return the paginated results for the current page
        const start = (subsPage.value - 1) * pageSize.value;
        const end = start + pageSize.value;

        //console.log("paginatedProjects", filteredProjects.length);
        return filteredSubs.value.slice(start, end);
    }

    function renderClientProjectOptions(client) {
        var options = [];
        client.Projects.forEach(item => {
            options.push({ label: item.Name, value: item.Name });
        });
        return options;
    }

    function closeFirstTimePopup() {
        showFirstTimePopup.value = false;
    }

    onMounted(() => {

        read();

        setTimeout(() => {
            //console.log("clientList", clientList.value);
            //console.log("subContractorList", subContractorList.value);

            if (clientList.value && subContractorList.value && clientList.value.length == 0 && subContractorList.value.length == 0) {
                showFirstTimePopup.value = true;
            }
        }, 500);
       
        //console.log("subContractorList", subContractorList);

    });

</script>



<template>
    <div class="wrapper">
        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }">


            <div class="top" style="height:60px;"> </div>

            <h4 class="mb-6 font-semibold">My Contacts</h4>

            <div class="bg-gray-100 min-h-screen flex flex-col  p-4 rounded-xl">

                <!-- Client Contacts -->
                <div class="client-contacts">

                    <div class="title">Client Contacts</div>
                    <!-- Add New Button -->
                    <div style="display:flex; align-items:center;">
                        <div style="flex:1">

                            <n-input-group>
                                <n-input :style="{ width: '185px' }" placeholder="Search Client" v-model:value="searchByClients" />
                                <n-button type="primary" ghost @click="searchClients">
                                    Search
                                </n-button>
                            </n-input-group>


                        </div>
                        <div class="btn btn-success full-button" style="width: 200px; margin: 16px 0; font-weight: normal; " @click="addNewClient">
                            Add a New Client
                            <svg style="margin-left: 4px;" width="24px" height="24px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-2.4" y="-2.4" width="28.80" height="28.80" rx="14.4" fill="#ffffff" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 6L12 18" stroke="#6655e3" stroke-width="2" stroke-linecap="round"></path> <path d="M18 12L6 12" stroke="#6655e3" stroke-width="2" stroke-linecap="round"></path> </g></svg>
                        </div>
                        <div class="short-button " @click="addNewClient" style="cursor: pointer; ">
                            <svg style="margin-left: 4px;" width="24px" height="24px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-2.4" y="-2.4" width="28.80" height="28.80" rx="14.4" fill="green" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 6L12 18" stroke="white" stroke-width="2" stroke-linecap="round"></path> <path d="M18 12L6 12" stroke="white" stroke-width="2" stroke-linecap="round"></path> </g></svg>
                        </div>
                    </div>


                    <!-- Desktop View -->
                    <div class="table-container">
                        <table class="clients-table" >
                            <thead>
                                <tr>
                                    <th>Client/Homeowner</th>

                                    <th>Phone Number</th>
                                    <th>Email</th>
                                    <th style="width:120px;"></th>
                                </tr>
                            </thead>
                            <tbody >
                                <tr v-for="(client, index) in paginatedClients()" :key="index">
                                    <td style="font-weight:bold;">{{ client.FirstName }} {{client.LastName}}<br /><span class="client-name" v-if="client.BusinessName">{{ client.BusinessName }}</span></td>

                                    <td>{{ client.Phone }}</td>
                                    <td>{{ client.Email }}</td>
                                    <td>
                                        <div style="gap: 4px; display:flex;">
                                            <i class="btn-edit btn" @click="editClient(client)"></i>

                                            <i class="btn btn-project" v-if="client.Projects && client.Projects.length > 0" @click="showProjectSummary('client', client.Id)"></i>
                                            <i class="btn btn-project" style="visibility: hidden;" v-else ></i>

                                            <i class="btn btn-add-client" @click="addProject(client)"></i>

                                        </div>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Mobile View -->
                    <div class="cards-container">
                        <div class="client-card" v-for="(client, index) in paginatedClients()" :key="index" style="display:flex;">
                            <div style="flex: 1;">
                                <div style="font-weight:bold; font-size:14px;" v-if="client.BusinessName">{{ client.BusinessName }} </div>
                                <p><strong>Client/Homeowner:</strong> {{ client.FirstName }} {{ client.LastName }}</p>

                                <p><strong>Phone:</strong> {{ client.Phone }}</p>
                                <p><strong>Email:</strong> {{ client.Email }}</p>
                            </div>


                            <div>
                                <div><i class="btn btn-edit" @click="editClient(client)"></i></div>

                                <div v-if="client.Projects && client.Projects.length > 0">
                                    <i class="btn btn-project" @click="showProjectSummary('client', client.Id)"></i>
                                    
                                </div>

                                <div>
                                    <i class="btn btn-add-client" @click="addProject(client)"></i>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div class="row" style="display:flex; justify-content:center; flex:1; margin-top: 16px;">
                        <n-pagination v-model:page="clientsPage" :page-count="clientsPageCount" style="width:fit-content; height:fit-content;align-self:end;" />
                    </div>

                </div>


                <!-- Sub-Contractor Contacts -->
                <div class="sub-contacts">

                    <div class="title">Sub-Contractor Contacts</div>

                    <!-- Add New Button -->
                    <div style="display:flex; align-items:center; ">
                        <div style="flex:1">
                            <n-input-group>
                                <n-input :style="{ width: '185px' }" placeholder="Search Sub-Contractor" v-model:value="searchBySub" />
                                <n-button type="primary" ghost @click="searchSubs">
                                    Search
                                </n-button>
                            </n-input-group>

                        </div>
                        <div class="btn btn-success full-button" style="font-size:12px; width: 220px; margin: 16px 0; font-weight: normal;" @click="addNewSub">
                            Add a New Sub-Contractor
                            <svg style="margin-left: 4px;" width="24px" height="24px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-2.4" y="-2.4" width="28.80" height="28.80" rx="14.4" fill="#ffffff" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 6L12 18" stroke="#6655e3" stroke-width="2" stroke-linecap="round"></path> <path d="M18 12L6 12" stroke="#6655e3" stroke-width="2" stroke-linecap="round"></path> </g></svg>
                        </div>
                        <div class="short-button " @click="addNewSub" style="cursor:pointer; ">
                            <svg style="margin-left: 4px;" width="24px" height="24px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-2.4" y="-2.4" width="28.80" height="28.80" rx="14.4" fill="green" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 6L12 18" stroke="white" stroke-width="2" stroke-linecap="round"></path> <path d="M18 12L6 12" stroke="white" stroke-width="2" stroke-linecap="round"></path> </g></svg>
                        </div>
                    </div>


                    <!-- Desktop View -->
                    <div class="table-container">
                        <table class="sub-table">
                            <thead>
                                <tr>
                                    <th>Business Name</th>
                                    <th>Address</th>
                                    <th>Phone Number</th>
                                    <th>Email</th>
                                    <th style="width:120px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(sub, index) in paginatedSubs()" :key="index">
                                    <td style="font-weight:bold;">{{ sub.Name }}<br /><span class="client-name">{{ sub.ContactFirstName }} {{ sub.ContactLastName }}</span></td>
                                    <td>{{ sub.Address }}</td>
                                    <td>{{ sub.Phone }}</td>
                                    <td>{{ sub.Email }}</td>
                                    <td>
                                        <div style="gap: 4px; display:flex;">
                                            <i class="btn btn-edit" @click="editSub(sub)"></i>
                                            <i class="btn btn-project" v-if="sub.Projects && sub.Projects.length > 0" @click="showProjectSummary('subcontractor', sub.Id)"></i>                                   
                                            <i class="btn btn-project" style="visibility: hidden;" v-else ></i>
                                            <i class="btn btn-add-client" @click="addSubToProject(sub)"></i>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Mobile View -->
                    <div class="cards-container">
                        <div class="sub-card" v-for="(sub, index) in paginatedSubs()" :key="index" style="display:flex;">
                            <div style="flex: 1;">
                                <div style="font-weight:bold; font-size:14px;">
                                    {{ sub.Name }}
                                    <p><strong>Name:</strong> {{ sub.ContactFirstName }} {{ sub.ContactLastName }}</p>
                                    <p><strong>Address:</strong> {{ sub.Address }}</p>
                                    <p><strong>Phone:</strong> {{ sub.Phone }}</p>
                                    <p><strong>Email:</strong> {{ sub.Email }}</p>
                                </div>

                            </div>
                            <div>
                                <div> <i class="btn btn-edit" style="float:right;" @click="editSub(sub)"></i></div>
                               
                                <div>
                                    <i class="btn btn-project" v-if="sub.Projects && sub.Projects.length > 0" @click="showProjectSummary('subcontractor', sub.Id)"></i>
                                </div>
                                <div>
                                    <i class="btn btn-add-client" @click="addSubToProject(sub)"></i>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div class="row" style="display:flex; justify-content:center; flex:1; margin-top: 16px;">
                        <n-pagination v-model:page="subsPage" :page-count="subsPageCount" style="width:fit-content; height:fit-content;align-self:end;" />
                    </div>

                </div>

            </div>

        </div>


        <CustomPopup :visible="showPopup"
                     :iconSrc="popupIconSrc"
                     :iconColor="iconColor"
                     :title="popupTitle"
                     :content="content"
                     :cancelText="cancelText"
                     :confirmText="confirmText"
                     :confirmButtonType="confirmButtonType"
                     :confirmAction="currentConfirmAction"
                     :autoClose="autoClose"
                     @cancel="closePopup" />

        <SubcontractorModal :data="subContractorData" :visible="showSubcontractorModal" @close-modal="showSubcontractorModal = false" @save="save" ref="subcontractor" @saveProfile="saveSubcontractor" @alert="alertMessage" />
        <ClientModal :data="clientData" :visible="showClientModal" @close-modal="showClientModal = false" @save="save" ref="client" @saveProfile="saveClient" @alert="alertMessage" />

        <ProjectsModal :subContractor="selectedSubContractor" :visible="showProjectsModal" @close-modal="showProjectsModal = false" @alert="alertMessage"  @addToProject="saveSubcontractorWithProject" />

        <ProjectSummaryModal :UserId="userId" :Type="type" :List="list" :visible="showProjectSummaryModal" @close-modal="showProjectSummaryModal = false" @alert="alertMessage" @goToProject="goToProject"/>
        <FirstTimePopup 
                    :visible="showFirstTimePopup"
                    :title="firstTimePopupTitle"
                    :content="firstTimeContent" 
                    :confirmText="firstTimeConfirmText"
                    :confirmAction="firstTimeCurrentConfirmAction" 
                    @cancel="closeFirstTimePopup" />

    </div>

</template>


<style scoped>
    #app {
        height: 100vh;
    }

    .nav-link {
        color: white;
        width: 100%;
    }

        

    .container {
        min-height: 100vh;
        height: 100%;
    }

    .title {
        padding: 8px;
    }


    /* General Styles */
    .client-contacts {
        padding: 16px;
    }

    .add-button-container {
        text-align: right;
        margin-bottom: 16px;
    }

    .table-container {
        display: block;
        overflow-x: auto; /* Enable horizontal scrolling for tables */
    }

    .clients-table {
        width: 100%;
        border-collapse: collapse;
        text-align: left;
        font-size: 0.9rem;
     
    }

        .clients-table th,
        .clients-table td {
            padding: 8px;
            border: 1px solid #ddd;
            font-size: 12px;
        }

        .clients-table th {
            background-color: #007bff;
            color: white;
            text-align: left;
        }

    .client-name {
        font-weight: normal;
        font-style: italic;
        color: #555;
    }

    /* General Styles */
    .sub-contacts {
        padding: 16px;
    }

    .sub-table {
        width: 100%;
        border-collapse: collapse;
        text-align: left;
        font-size: 0.9rem;
        
    }

        .sub-table th,
        .sub-table td {
            padding: 8px;
            border: 1px solid #ddd;
            font-size: 12px;
        }

        .sub-table th {
            background-color: #ff9800;
            color: white;
            text-align: left;
        }

    .client-name {
        font-weight: normal;
        font-style: italic;
        color: #555;
    }


    .sub-card {
        background-color: #f9f9f9;
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 12px;
        margin: 8px 0px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
        min-width: 300px;
    }

        .sub-card h3 {
            font-size: 1.1rem;
            margin-bottom: 8px;
        }

        .sub-card p {
            margin: 4px 0;
            font-size: 12px;
        }

    /* Cards for Mobile View */
    .cards-container {
        display: none; /* Hide by default */
    }


    .full-button {
        display: block;
    }

    .short-button {
        display: none;
    }

    .client-card {
        background-color: #f9f9f9;
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 12px;
        margin: 8px 0px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
        min-width: 300px;
    }

        .client-card h3 {
            font-size: 1.1rem;
            margin-bottom: 8px;
        }

        .client-card p {
            margin: 4px 0;
            font-size: 12px;
        }



    /* Responsive Styles */
    @media (max-width: 768px) {
        .table-container {
            display: none; /* Hide table for mobile */
        }

        .cards-container {
            display: block; /* Show cards for mobile */
        }

        .full-button {
            display: none;
        }

        .short-button {
            display: block;
        }
    }

    /* Responsive Styles */
    @media (max-width: 600px) {
        .p-4{padding: .5rem !important;}
        .client-contacts{padding: 8px;}
    }
</style>

